import { User } from "app/core/user/user.types";
import { HttpService } from "./http.service";
import { ServiceProvider } from "./service.provider";
import { UserImpl } from "app/models/user";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

export abstract class BaseService extends HttpService {
	//Inter connection listner set from the auth service on the time login
	//isOnline: boolean = true;

	constructor(public endpoint: string, public provider: ServiceProvider) {
		super(endpoint, provider.http,);
	}

	protected getList(method?: string, limit?: number, page?: number) {
		if (limit != undefined && limit != null && page != undefined && page != null) {
			method = method + "?limit=" + limit + "&page=" + page;
		}

		return new Promise((resolve, reject) => {
			this.get(method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected getById(id: number) {
		return this.getRecord("/" + id);
	}

	protected getRecord(method: string) {
		return new Promise((resolve, reject) => {
			this.get(method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected save(data, method?,skipLoading?:boolean) {
		return new Promise((resolve, reject) => {
			this.post(data, method,skipLoading).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	// protected saveGlobal(data, method?) {
	// 	return new Promise((resolve, reject) => {
	// 		this.postGlobal(data, method).subscribe(
	// 			(response) => {
	// 				this.processResponse(resolve, reject, response);
	// 			},
	// 			(err) => {
	// 				reject(this.processError(err));
	// 			}
	// 		);
	// 	});
	// }

	protected update(data, method?: string) {
		return new Promise((resolve, reject) => {
			this.put(data, method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	public deleteRecord(id) {
		return new Promise((resolve, reject) => {
			this.delete(id).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	public deleteWithBody(data,id) {
		return new Promise((resolve, reject) => {
			this.deleteData(data, id).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	private processResponse(resolve, reject, response) {
		if (response.status === "SUCCESSFUL")  //FIXME: response.status === "SUCCESSFUL"
		{
			resolve(response);
		} else {
			reject(this.processError(response.error));
		}
	}

	private getSupportContact(): string {
		const supportEmail = this.provider?.util?.getWebComponentInputParams()?.lpmConfig?.supportEmail;
		return supportEmail ? `<a href="mailto:${supportEmail}">contact support</a>` : 'contact support';
	}

	protected processError(err) {
		//console.log(" ----------Exception from server side Base Service--------- ");
		console.log(err)
		const supportMessage = this.provider?.util?.getWebComponentInputParams()?.lpmConfig?.supportMessage;
		if (!this.isOnline()) {
			err.message =
				supportMessage ||
				`Server connection error! Please check your internet connection and try again or ${this.getSupportContact()} for further assistance.`;
			this.provider.showError(err.message);
			return err;
		}
		if (err.code === "401") {
			if (window.location.href.indexOf("login") != -1) {
			  // lolly
			  let user: UserImpl = this.provider?.util?.getUserFromSession();
			  if (!user || user == null) return err;
			}
			this.provider.util.logout(
			  "token-expire",
			);
			//this.provider.logout();
		  }
		 else if (err.code === "403") {
			this.provider.accessDenied(err.message);
		} else if (err.code === "1301") {
			//this.showSessionConfirmDialog();
		} else if (err.code === "1302") {
			// this.provider.util.logout("session-expire", this.getHeaders().get("LOLLY_USER_TYPE"));
			// this.provider.logout();
		} else {
			if (!err.message || err.message.trim() == "") {
				this.provider.showError(supportMessage || `An unexpected error occurred. Please try again or ${this.getSupportContact()} for further assistance.`);
			} else {
				this.provider.showError(err.message);
			}
			return err;
		}
	}

	public getData(res: any) {
		return res.data;
	}

	public getMeta(res: any) {
		return res.meta;
	}

	public getSimData(res: any) {
		return res;
	}

	public getCount(res : any){
		return this.getMeta(res).total;
	}

	/**
	 * this will update the record with method
	 */
	// protected update(data, method) {
	// 	return new Promise((resolve, reject) => {
	// 		this.put(data, method).subscribe(
	// 			(response) => {
	// 				if (response.status === 'SUCCESSFUL') {
	// 					resolve(response);
	// 					console.log(response);
	// 				}
	// 				if (response.status === 'ERROR') {
	// 					reject(this.errorHanding(response.error));
	// 				}
	// 				// console.log(response)
	// 			},
	// 			(err) => {
	// 				//  this.toastr.error(err.status.message.details, 'Oopss!');
	// 				reject(err);
	// 				console.log(err);
	// 			}
	// 		);
	// 	});
	// }

	// protected searchApi(value, pageNo, limit) {
	// 	const index = pageNo - 1;
	// 	// '/api/users/search/'
	// 	return new Promise((resolve, reject) => {
	// 		this.get('/search/' + value + '?limit=' + limit + '&page=' + index).subscribe(
	// 			(response) => {
	// 				if (response.status === 'SUCCESSFUL') {
	// 					resolve(response.data);
	// 					console.log(response);
	// 				}
	// 				if (response.status === 'ERROR') {
	// 					reject(this.errorHanding(response.error));
	// 				}
	// 			},
	// 			(err) => {
	// 				//  this.toastr.error(err.status.message.details, 'Oopss!');
	// 				reject(err);
	// 				console.log(err);
	// 			}
	// 		);
	// 	});
	// }

	protected uploadImg(data, method?) {
		return new Promise((resolve, reject) => {
			this.uploadImage(data, method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	protected uploadImgPut(data, method?) {
		return new Promise((resolve, reject) => {
			this.uploadPut(data, method).subscribe(
				(response) => {
					this.processResponse(resolve, reject, response);
				},
				(err) => {
					reject(this.processError(err));
				}
			);
		});
	}

	isOnline(): boolean {
		return navigator.onLine;
	}

	signout(path) {
		return new Promise((resolve, reject) => {
			this.post(null, path).subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);

						//UnSubscribe to check internet connection listner
						//this.subs.unsubscribe();
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}

	//When user wants to keep the new user session
	public revokeCurrentUserSession() {
		return new Promise((resolve, reject) => {
			this.post(null, "/api/auth/signin/cs" + this.provider.getAddOnQueryParam()).subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}
/*
	private defaultViewSource = new BehaviorSubject<string>('explorer');
    defaultView$ = this.defaultViewSource.asObservable();

    setDefaultView(view: string): void {
        this.defaultViewSource.next(view);
    }
	*/
}
